"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorDNSTypes = void 0;
var ValidatorDNSTypes;
(function (ValidatorDNSTypes) {
    ValidatorDNSTypes["IPV4"] = "IPV4";
    ValidatorDNSTypes["IPV6"] = "IPV6";
    ValidatorDNSTypes["STRING2_DOMAIN_NAME_OPT_DOT"] = "STRING2_DOMAIN_NAME_OPT_DOT";
    ValidatorDNSTypes["STRING2_DOMAIN_NAME_MX"] = "STRING2_DOMAIN_NAME_MX";
    ValidatorDNSTypes["STRING1_CNAME_A_SAME_VALIDATION"] = "STRING1_CNAME_A_SAME_VALIDATION";
    ValidatorDNSTypes["STRING2_CNAME"] = "STRING2_CNAME";
    ValidatorDNSTypes["STRING2_DNAME"] = "STRING2_DNAME";
    ValidatorDNSTypes["STRING2_TXT"] = "STRING2_TXT";
    ValidatorDNSTypes["STRING2_SRV"] = "STRING2_SRV";
    ValidatorDNSTypes["STRING1"] = "STRING1";
    ValidatorDNSTypes["STRING1_NOT_AT"] = "STRING1_NOT_AT";
    ValidatorDNSTypes["REQUIRED"] = "REQUIRED";
    ValidatorDNSTypes["NUMERIC"] = "NUMERIC";
})(ValidatorDNSTypes || (exports.ValidatorDNSTypes = ValidatorDNSTypes = {}));
